// extracted by mini-css-extract-plugin
export default {"box":"style_box__-86LN","arrowIconWrap":"style_arrowIconWrap__mR3mZ"};